/**
 * Author: Claude Code
 * Generation: Rules page explaining game mechanics
 * Version: v3.2.42
 * Modified: 2025-10-09
 */
import { useNavigate } from 'react-router-dom';

export default function RulesPage() {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <div className="page active">
        <div className="content-card">
          <div className="card-header">
            <h2 className="card-title">Game Rules</h2>
            <p className="card-description">Everything you need to know before entering the battlefield</p>
          </div>
          <div className="card-body">
            <div className="rules-container">
              <div className="rule-section">
                <h3 className="rule-heading">🎯 Objective</h3>
                <p className="rule-text">Create an AI-powered agent and be the last one standing in this next-generation battle royale. Your agent will make autonomous decisions based on the personality and strategy you define.</p>
              </div>

              <div className="rule-section">
                <h3 className="rule-heading">🎮 Gameplay</h3>
                <ul className="rule-list">
                  <li>Create your custom AI agent with unique attributes</li>
                  <li>Define its personality and combat behavior</li>
                  <li>Watch your AI make real-time strategic decisions</li>
                  <li>Survive against other players' AI agents</li>
                </ul>
              </div>

              <div className="rule-section">
                <h3 className="rule-heading">⚔️ Combat System</h3>
                <ul className="rule-list">
                  <li>Turn-based combat with autonomous decision making</li>
                  <li>Collect weapons and resources across the map</li>
                  <li>Use healing items to restore health</li>
                  <li>Avoid the shrinking safe zone that deals damage</li>
                </ul>
              </div>

              <div className="rule-section">
                <h3 className="rule-heading">🏆 Victory</h3>
                <ul className="rule-list">
                  <li>Eliminate all opponents to win</li>
                  <li>Earn rewards based on your placement</li>
                  <li>Higher placement = more MoMo coins</li>
                </ul>
              </div>

              <div className="rule-section">
                <h3 className="rule-heading">💡 Tips</h3>
                <ul className="rule-list">
                  <li>Balance your agent's stats wisely</li>
                  <li>A well-defined strategy beats raw stats</li>
                  <li>Monitor the safe zone carefully</li>
                  <li>Resource management is crucial</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              className="btn btn-primary btn-lg"
              style={{ width: '100%' }}
              onClick={() => navigate('/lobby')}
            >
              Enter Lobby
              <span>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
